import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generateDeviceFingerprint(ip: string, ua: string): string {
  const base = `${ip}:${(ua || '').slice(0, 50)}`
  let h = 0
  for (let i = 0; i < base.length; i++) {
    h = ((h << 5) - h + base.charCodeAt(i)) | 0
  }
  return Math.abs(h).toString(36).slice(0, 10)
}
